/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, Typography, Grid, Box, IconButton } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import services from '../Service';
import Button from "@material-ui/core/Button";
import { ToastContainer, toast } from 'react-toastify';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import CSVReader from 'react-csv-reader';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { CSVLink } from 'react-csv';
import SearchNotFound from '../../../SearchNotFound';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import MenuItem from '@material-ui/core/MenuItem';
import { getDate } from 'date-fns';
import dayjs from 'dayjs';

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function AddCustomerOrders(props) {

  const navigate = useNavigate();
  const screenCode = 'OTHERCUSTOMERORDERBULKUPLOAD';
  const [isUploadButtonEnable, setIsUploadButtonEnable] = useState(true);
  const [isTableEnable, setIsTableEnable] = useState(true);
  const [group, setGroup] = useState([]);
  const [farmersCSVData, setOrdersCSVData] = useState([]);
  const [isFileChosen, setIsFileChosen] = useState(false);
  const [fileInfo, setFileInfo] = useState({});
  const [customerOrderBulkUpload, setCustomerOrderBulkUpload] = useState([]);
  const [Datevalue, setDateValue] = React.useState(new Date().setDate(new Date().getDate() - 1));

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  const [formData, setFormData] = useState({
    orderTypeID: "0",
    date: new Date().toISOString().split('T', 1)
  });

  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: false,
    submitButtonName: "Upload",
    pageheadername: "Other Customer Orders Bulk Upload"
  });

  const CustomerOrdersSaveSchema = Yup.object().shape({
    orderTypeID: Yup.number().min(1, 'Please Select Order Type').required('Order Type Required'),
    date: Yup.date().min(1).min(1, 'Please Select Date').required('Date required')

  });

  const formik = useFormik({
    initialValues: {
      orderTypeID: formData.orderTypeID,
      date: formData.date
    },

    validationSchema: CustomerOrdersSaveSchema,
    onSubmit: (values) => {
      if (pageProps.isEdit > 0) {
        UpdateCustomerOrders(values, pageProps.editingID)
      } else {
        trackPromise(saveCustomerOrders());
      }
    },
  });

  const { errors, setErrors, setValues, touched, setTouched, handleSubmit, isSubmitting, getFieldProps, validateForm, values } = formik;

  useEffect(() => {
    setCustomerOrderBulkUpload([]);
    setIsTableEnable(true);
    clearAll();
  }, [Datevalue]);

  useEffect(() => {
    trackPromise(GetAllOrderTypes());
  }, []);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - customerOrderBulkUpload.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  async function saveCustomerOrders() {
    if (customerOrderBulkUpload.length > 0) {
      var res = await services.SaveCustomerOrdersBulk(customerOrderBulkUpload);
      if (res.statusCode == 'Success') {
        toast.success(res.message);
        clearAll();
      }
      else {
        toast.error(res.message);
      }
    }
    else {
      toast.error("Please select a correct file.");
    }
  }

  async function uploadCustomerOrders(data, type) {
    if (type.type === "text/csv") {
      setCustomerOrderBulkUpload([])
      let datarest = await Promise.all(data.map(async data => {

        var customerOrderDetails = {
          date: new Date(Datevalue),
          orderTypeID: values.orderTypeID,
          outletCode: data.outletCode,
          skuCode: data.skuCode,
          quantity: parseFloat(data.quantity),
          createdBy: parseInt(TokenDecoder.getUserIDFromToken())
        }
        setCustomerOrderBulkUpload(customerOrderBulkUpload => [...customerOrderBulkUpload, customerOrderDetails]);
        setIsTableEnable(false)
      }))

      var errorList = [];
      datarest.map((itemx) => {
        if (itemx != undefined) {
          errorList.push(itemx);
        }
      })
      setOrdersCSVData(errorList);
    }

    else {
      toast.error(type.name + " is not valid . please select a CSV file.");
      setTimeout(() => {
      }, 3000);
    }
  }

  async function clearAll() {
    var customerOrderDetails = {
      outletCode: "",
      skuCode: "",
      quantity: 0,
      date: Datevalue,
    }
    setCustomerOrderBulkUpload([customerOrderDetails]);
    setIsFileChosen(false);
    setIsUploadButtonEnable(true);
    setIsTableEnable(true)
    document.querySelector('.csv-input').value = '';
  }

  const papaparseOptions = {
    header: true,
    dynamicTyping: false,
    quoteChar: '"',
    skipEmptyLines: true,
    parseNumbers: true,
    transformHeader: header => header.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '')
  };

  const handleForce = (data, fileInfo) => {
    setIsFileChosen(true);
    setFileInfo(fileInfo);
    uploadCustomerOrders(data, fileInfo);
    confirmUpload(data, fileInfo);
  }

  function confirmUpload(data, fileInfo) {
    setOrdersCSVData(data);
  }

  async function GetAllOrderTypes() {
    var res = await services.GetAllOrderTypes()
    if (res != null) {
      setGroup(res);
    }
  }

  useEffect(() => {
    getPermissions();
  }, []);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCUSTOMERORDERS');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });
    trackPromise(GetAllOrderTypes());
  }

  const csvHeaders = [
    { label: "outletCode", key: "outletCode" },
    { label: "skuCode", key: "skuCode" },
    { label: "Quantity", key: "quantity" },
  ];

  const csvData = [
    {
      outletCode: "", skuCode: "", quantity: "",
    },
  ];

  const csvData2 = [
    {
      outletCode: "OU00218", skuCode: "VGE0107", quantity: "344",
    },
  ];

  return (
    <>
      <LoadingComponent />
      <Page title="Other Customer Orders Bulk Upload  |  FAPS">
        <Container>
          <CommonPageHeader
            path="/dashboard"
            btname="Back"
            pageName={pageProps.pageheadername}
            leftButtonHidden={true}
          />
          <FormikProvider value={formik}>
            <ToastContainer
              position="bottom-right"
              pauseOnHover
            />
            <Form autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '5px' }} spacing={2}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Order Type *"
                      value={formik.values.orderTypeID}
                      onChange={formik.handleChange}
                      {...getFieldProps('orderTypeID')}
                      error={Boolean(touched.orderTypeID && errors.orderTypeID)}
                      helperText={touched.orderTypeID && errors.orderTypeID}
                    >
                      <MenuItem value={0} disabled>Select Order Type</MenuItem>
                      {group.map((option) => (
                        option.isActive ? (
                          <MenuItem key={option.orderTypeID} value={option.orderTypeID}>
                            {option.orderTypeName}
                          </MenuItem>
                        ) : null
                      ))}
                    </TextField>
                  </Grid>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Grid item md={4} xs={12}>
                      <DatePicker
                        fullWidth
                        size="small"
                        label="Date *"
                        openTo="day"
                        type="Date"
                        views={['year', 'month', 'day']}
                        value={Datevalue}
                        maxDate={dayjs().subtract(1, 'day').toDate()}
                        onChange={(newValue) => {
                          setDateValue(newValue);
                        }}
                        renderInput={(params) =>
                          <TextField
                            fullWidth
                            size="small"
                            {...params}
                          />}
                      />
                    </Grid>
                  </LocalizationProvider>
                </Stack>
                <br />
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Button variant="contained" color='secondary' component="span"
                    disabled={formik.values.groupID == 0 || formik.values.operationEntityID == 0 ? true : false}>
                    <CSVReader
                      label={isFileChosen ? 'File Chosen' : 'Choose File'}
                      inputStyle={{ display: 'none' }}
                      onFileLoaded={handleForce}
                      parserOptions={papaparseOptions}
                      inputId="react-csv-reader-input"
                      cssClass="csv-reader-input"
                    />
                  </Button>
                  {isFileChosen ? <span>{fileInfo.name}</span> : null}
                  <Button variant="contained" color='primary' component="span">
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      style={{ color: 'white' }}
                      filename={"Other Customer Orders Bulk Template.csv"}
                    >
                      Template
                    </CSVLink>
                  </Button>
                  <Button variant="contained" color='primary' component="span">
                    <CSVLink
                      data={csvData2}
                      headers={csvHeaders}
                      style={{ color: 'white' }}
                      filename={"Other Customer Orders Bulk Sample Template.csv"}
                    >
                      Sample Data
                    </CSVLink>
                  </Button>
                </Stack>
                <br />
                <Divider variant="middle" />
                <br />
                {isTableEnable == false ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Card style={{ justifycontent: 'center', width: '85rem' }} >
                      <TableContainer component={Paper} >
                        <Table aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="center">Outlet Code</TableCell>
                              <TableCell align="center">SKU Code</TableCell>
                              <TableCell align="center">Quantity</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(rowsPerPage > 0
                              ? customerOrderBulkUpload.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              : customerOrderBulkUpload
                            ).map((row, index, array) => {
                              return (
                                <TableRow
                                  key={row.skuCode}
                                >
                                  <TableCell align="center">
                                    {row.outletCode}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.skuCode}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.quantity}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                            {emptyRows > 0 && (
                              <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={6} />
                              </TableRow>
                            )}
                          </TableBody>

                          <TableFooter>
                            <TableRow>
                              <TablePagination
                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                colSpan={6}
                                count={customerOrderBulkUpload.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                  inputProps: {
                                    'aria-label': 'rows per page',
                                  },
                                  native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                              />
                            </TableRow>
                          </TableFooter>
                        </Table>
                      </TableContainer>
                    </Card>
                  </Stack> : <SearchNotFound searchQuery="Other Customer Orders Bulk Upload" />}
                {isTableEnable == false ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <LoadingButton
                      size="small"
                      type="button"
                      color='error'
                      variant="outlined"
                      disabled={pageProps.isEdit}
                      onClick={() => clearAll()}
                    >
                      Clear
                    </LoadingButton>
                    <LoadingButton
                      size="small"
                      type="submit"
                      color='secondary'
                      variant="outlined"
                      disabled={isTableEnable}
                    >
                      {pageProps.submitButtonName}
                    </LoadingButton>
                  </Stack> : null}
              </Stack>
            </Form>
          </FormikProvider>
        </Container>
      </Page >
    </>
  )
}